import { Typography } from "@mui/material";

export default function AdminUserDashboard() {
  return (
    <div>
      {/* <div style={{backgroundColor:'rgb(34, 47, 63)'}}> */}
      <div style={{backgroundColor:'black'}}>
        <div
          style={{
            minHeight: "600px",
            margin: "auto",
            width: "1000px",
            textAlign: "center",
          }}
        >
          <div
            style={{
              borderColor: "white",
              borderStyle: "solid",
              width: "600px",
              height: "600px",
              margin: "auto",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src="/assets/vocalsaturator.png"
              alt="HE1 Harmonic Enhancer"
              style={{
                maxWidth: "95%",
                maxHeight: "95%",
                objectFit: "contain",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}